module.exports = __webpack_public_path__ + "static/media/vim.40c677f7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/vim.png
// module id = 209
// module chunks = 0